import { Component, OnInit, Output, Input , EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from './utility.service';
@Component({
  selector: 'calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendarComponent implements OnInit {
  @Input() events :any; 
  @Input() schedule :any; 
  @Input() slot :any; 
  @Output() getevent : EventEmitter<any> = new EventEmitter<any>();
  @Output() booking : EventEmitter<any> = new EventEmitter<any>();
  title = 'app';
  dayArray : object[] = null;
  days : object[] = null;
  weekDays :  object[] = null;
  displayDays : object[] = null;
  selectedDate = null;
  selectedMonth : string;
  selectedWeek : string;
  selectedWeekHeader : string;
  selectedDayHeader : string;
  selectedDay : string;
  taskAvailable : any = null;
  calendarType = "M";
  constructor(private _utilitySrv : UtilityService) {
    
  }
  setEvent(type: string,actionType : string, selected : string ) {
    this.getevent.emit({"type" : type,"actionType" :actionType, "selected" : selected });
  }
  getPreviousMonthPage() {
    if(this.calendarType ==='M') {
      this.days = this._utilitySrv.getWeekDaysNameList();
      let prvDate = new Date(this.selectedDate);
      prvDate.setMonth(prvDate.getMonth() - 1);
      this.selectedDate = prvDate;
      this.selectedMonth = this._utilitySrv.getSelectedMonthDetail(this.selectedDate.getMonth(), this.selectedDate.getFullYear())
      this.dayArray = this._utilitySrv.getMonthPage(this.selectedDate .getFullYear(), this.selectedDate .getMonth(), 1);
      this.setEvent('M', 'PRV', (this.selectedDate.getMonth() + 1) + '/' +this.selectedDate.getFullYear() );
    } else if(this.calendarType ==='W') {
      this.selectedWeek = this._utilitySrv.getPreviousWeek(this.selectedWeek);
      this.weekDays = this._utilitySrv.getWeekDaysNameWithDateList(this.selectedWeek.split(' ')[0]);
      this.selectedWeekHeader = this._utilitySrv.formatWeekName(this.selectedWeek);
      this.dayArray = this._utilitySrv.getWeekPage(this.selectedWeek.split(' ')[0], this.slot);
      this.setEvent('W', 'PRV',this.selectedWeek );
    } else {
      this.selectedDate =this._utilitySrv.substractDays(this.selectedDate, 1);
      let m = (this.selectedDate.getMonth() + 1).toString();
      if(m.length==1) {
        m = '0'+m;
      }
      let d = this.selectedDate.getDate().toString();
      if(d.length==1) {
        d = '0'+d;
      }
      var dateStr  =   this.selectedDate.getFullYear() + '-' + m + '-' + d;
     // var dateStr  =   this.selectedDate.getFullYear() + '-' + (this.selectedDate.getMonth() + 1) + '-' + this.selectedDate.getDate();
      this.displayDays = this._utilitySrv.getNameWithDateList(dateStr);
      this.selectedDayHeader = this._utilitySrv.formatDayName(this.selectedDate);
      this.dayArray = this._utilitySrv.getDayPage(dateStr, this.slot);
      this.setEvent('D', 'PRV',dateStr );
    }
   
  }
  getNextMonthPage() {
    if(this.calendarType ==='M') {
      this.days = this._utilitySrv.getWeekDaysNameList();
      let nextDate = new Date(this.selectedDate.getFullYear(), this.selectedDate.getMonth(), 1);
      this.selectedDate = new Date(nextDate.setMonth(nextDate.getMonth() + 1));
      this.selectedMonth = this._utilitySrv.getSelectedMonthDetail(this.selectedDate.getMonth(), this.selectedDate.getFullYear());
      this.dayArray = this._utilitySrv.getMonthPage(this.selectedDate .getFullYear(), this.selectedDate .getMonth(), 1);
      this.setEvent('M', 'NXT', (this.selectedDate.getMonth() + 1) + '/' +this.selectedDate.getFullYear() );

    } else if(this.calendarType ==='W') {
      this.selectedWeek = this._utilitySrv.getNextWeek(this.selectedWeek);
      this.weekDays = this._utilitySrv.getWeekDaysNameWithDateList(this.selectedWeek.split(' ')[0]);
      this.selectedWeekHeader = this._utilitySrv.formatWeekName(this.selectedWeek);
      this.dayArray = this._utilitySrv.getWeekPage(this.selectedWeek.split(' ')[0], this.slot);
      this.setEvent('W', 'NXT',this.selectedWeek );
    } else {
      this.selectedDate =this._utilitySrv.addDays(this.selectedDate, 1);
      //var dateStr  =   this.selectedDate.getFullYear() + '-' + (this.selectedDate.getMonth() + 1) + '-' + this.selectedDate.getDate();
      let m = (this.selectedDate.getMonth() + 1).toString();
      if(m.length==1) {
        m = '0'+m;
      }
      let d = this.selectedDate.getDate().toString();
      if(d.length==1) {
        d = '0'+d;
      }
      var dateStr  =   this.selectedDate.getFullYear() + '-' + m + '-' + d;
      this.displayDays = this._utilitySrv.getNameWithDateList(dateStr);
      this.selectedDayHeader = this._utilitySrv.formatDayName(this.selectedDate);
      this.dayArray = this._utilitySrv.getDayPage(dateStr, this.slot);
      this.setEvent('D', 'NXT',dateStr );
    }
  }
  getCurrentMonthPage() {
    this.selectedDate = this._utilitySrv.getCurrentDate();
    if(this.calendarType ==='M') {
      this.days = this._utilitySrv.getWeekDaysNameList();
      this.selectedMonth = this._utilitySrv.getSelectedMonthDetail(this.selectedDate.getMonth(), this.selectedDate.getFullYear());
      this.dayArray = this._utilitySrv.getMonthPage(this.selectedDate .getFullYear(), this.selectedDate .getMonth(), 1);
      this.setEvent('M', 'CUR', (this.selectedDate.getMonth() + 1) + '/' +this.selectedDate.getFullYear() );

    } else if(this.calendarType ==='W') {
      this.selectedWeek = this._utilitySrv.getCurrentWeek();
      this.weekDays = this._utilitySrv.getWeekDaysNameWithDateList(this.selectedWeek.split(' ')[0]);
      this.selectedWeekHeader = this._utilitySrv.formatWeekName(this.selectedWeek);
      this.dayArray = this._utilitySrv.getWeekPage(this.selectedWeek.split(' ')[0], this.slot);
      this.setEvent('W', 'CUR',this.selectedWeek );
    } else {
      let m = (this.selectedDate.getMonth() + 1).toString();
      if(m.length==1) {
        m = '0'+m;
      }
      let d = this.selectedDate.getDate().toString();
      if(d.length==1) {
        d = '0'+d;
      }
      var dateStr  =   this.selectedDate.getFullYear() + '-' + m + '-' + d;
      this.displayDays = this._utilitySrv.getNameWithDateList(dateStr);
      this.selectedDayHeader = this._utilitySrv.formatDayName(this.selectedDate);
      this.dayArray = this._utilitySrv.getDayPage(dateStr, this.slot);
  
      this.setEvent('D', 'CUR',dateStr );;
    }
  }
  setCalendarType(type : string){
    this.calendarType = type;
    this.getCurrentMonthPage();
  }
  ngOnInit() {
    this.getCurrentMonthPage();
    
  }

  isFreeze(date : string, startTime: string, endTime : string) {
    if(this.schedule !== undefined && this.schedule.length>0) {
      let tasks =   this.schedule.filter((data)=> 
          (data.StartDate.split('/')[0]+'-' + this._utilitySrv.monthShortNames[parseInt(data.StartDate.split('/')[1])-1] +'-' +data.StartDate.split('/')[2]) === date
            //     
        );
    
      if(tasks.length>0) {
          let tasksForTime = tasks[0].AppointmentSchedule.filter((task) =>
            new Date(date + ' ' + task.AppointmentTime) >= new Date(date + ' ' + startTime) && new Date(date + ' ' + task.AppointmentTime) <= new Date(date + ' ' + endTime)   
          )
          if(tasksForTime.length>0 && tasksForTime[0].AppointmentIsScheduledActive===false) {
            return true;
          } else {
            return false;
          }
      } else {
        return false;
      }
    } else {
       return false;
    }
  }
  getData(date : string, startTime: string, endTime : string) {
    
   if( this.events !== undefined) {
        let tasks =   this.events.Days.filter((data)=> 
        data.date === date
          //     
      );
      if(tasks.length>0) {
          let tasksForTime = tasks[0].tasks.filter((task) =>
            new Date(date + ' ' + task.Time) >= new Date(date + ' ' + startTime) && new Date(date + ' ' + task.Time) <= new Date(date + ' ' + endTime)   
          )
          
          return [{"date": date,"tasks" : tasksForTime}];
      } else {
        return tasks;
      }
   } else {
     return [{"date": date,"tasks" : []}];
   }
   
    // debugger;
   
  }
  closeInfoBox(evt,task) {
    task.isClicked = false;
  }

   bookAppointment(time: string, date: string, startTime: string, endTime : string) {
        debugger;

           if( this.events !== undefined) {
            let tasks =   this.events.Days.filter((data)=> 
            data.date === date
              //     
          );
          if(tasks.length>0) {
              let tasksForTime = tasks[0].tasks.filter((task) =>
                new Date(date + ' ' + task.Time) >= new Date(date + ' ' + startTime) && new Date(date + ' ' + task.Time) <= new Date(date + ' ' + endTime)   
              )
              if(tasksForTime.length==0) {
                this.booking.emit({time: time, date: date});     
              }
           //   return [{"date": date,"tasks" : tasksForTime}];
          } else {
            this.booking.emit({time: time, date: date});
           // return tasks;
          }
       } else {
        this.booking.emit({time: time, date: date});
        // return [{"date": date,"tasks" : []}];
       }
        
   }

}



// WEBPACK FOOTER //
// ./src/app/section/appointment/calendar/calendar.component.ts